import React from "react";

const SummerSchoolSparkContext = React.createContext();

export { SummerSchoolSparkContext };
